import { Component, OnInit, Inject} from '@angular/core';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { environment } from 'src/environments/environment';
import { MyteamsService } from './../_services/myteams.service';
import { Playerinfobox2Component } from 'src/app/playerinfobox2/playerinfobox2.component';
import { MainService } from './../_services/main.service';

@Component({
  selector: 'app-matchup',
  templateUrl: './matchup.component.html',
  styleUrls: ['./matchup.component.scss']
})
export class MatchupComponent implements OnInit {
  sub_isMobileScreen: Subscription;
  isMobile = false;
  user: any = null;
  isMac = false;
  imgVersion = '1.1115';
  darkMode = false;
  browserName = '';
  darkModeExt = '';
  isLoading = true;
  contest: any = {};
  contestOpp: any = {};
  requestLeft = 0;
  allImgs = [];
  imageData = {};
  bucketURL = `${environment.assetURL}/assets/default/images/`;
  playerURL = `${environment.assetURL}/assets/uploads/players/`;
  playerImgFolder = `assets/uploads/players/`;
  showCanvasSS = false;
  teamSlug = '';
  oppTeamSlug = '';
  lgId = 0;
  ownTeamImg = '';
  oppTeamImg = '';
  games = {
    0: 'all',
    1: 'nhl',
    2: 'nfl',
    3: 'mlb',
    4: 'nba',
    5: 'pga'
  };
  
  // hard-coded position translations for display
  positions = {
    'FLEX': 'FX',
    'UTIL': 'UT',
    'WR-TE': 'WT',
    'SFLEX': 'SF',
    'DEF': 'D'
  }
  
  constructor(private store: Store<any>, private _mainService: MainService, private _myTeamsService: MyteamsService, private router: Router, public activeRoute: ActivatedRoute, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) private data) { 
    if (navigator.appVersion.indexOf("Mac")!= -1) {
      this.isMac = true;
    }
    
    if (navigator.userAgent.match(/AppleWebKit/) && ! navigator.userAgent.match(/Chrome/)) {
      this.browserName = 'safaribrowser';
    }
    
    this.store.select('DarkModeReducer').subscribe(state => {
      if (state.length > 0) {
        this.darkMode = state[0].isDarkMode;
        this.darkModeExt = this.darkMode ? '-dark' : '';
      }
    });
    
    this.store.select('authData').subscribe(state => {
      if (state[0]) {
        this.user = state[0];
      }
    });
    
    this.sub_isMobileScreen = this.store.select('isMobileScreen').subscribe(state => {
      if (state.length > 0) {
        this.isMobile = state[0];
      }
    });
  }

  ngOnInit() {
    let lgmData = this.data.lgmData;
    this.lgId = parseInt(lgmData.league_id);
    this.teamSlug = lgmData.slug;
    this.loadContest();
  }
  
  ngOnDestroy() {
  }
  
  loadContest() {
    this.isLoading = true;
    this._myTeamsService.getContestPlayers(this.teamSlug).subscribe(res => {
      if (res.status == true) {
        if (res.entities.league_id != this.lgId) {
          this.router.navigate(['/lobby']);
        }
        else {
          this.contest = {};
          this.contest.status = 'success';
          this.contest.data = res.entities;
          
          this.contest.data.opp_list = [];
          if (this.contest.data.lgm_list != null && this.contest.data.lgm_list.length) {
            this.contest.data.lgm_list.forEach(lgm => {
              if (lgm.slug != this.teamSlug) {
                this.contest.data.opp_list.push(lgm);
                if (!this.oppTeamSlug) {
                  this.oppTeamSlug = lgm.slug;
                  this.loadOppContest();
                }
                else if (this.oppTeamSlug == lgm.slug) {
                  this.loadOppContest();
                }
              }
              else {
                this.ownTeamImg = lgm.team_image;
              }
            });
          }
          
          if (this.contest.data.weekSlider != null && this.contest.data.weekSlider.length) {
            let selected = this.contest.data.weekSlider.filter(w => w.selected == 1)[0];
            if (selected == null) selected = this.contest.data.weekSlider[0];
            this.contest.data.selectedWeek = selected.value;
          }
        }
      } 
      else {
        this.router.navigate(['/lobby']);
      }
    });
  }
  
  loadOppContest() {
    this.isLoading = true;
    this._myTeamsService.getContestPlayers(this.oppTeamSlug).subscribe(res => {
      if (res.status == true) {
        if (res.entities.league_id != this.lgId) {
          this.router.navigate(['/lobby']);
        }
        else {
          this.contestOpp = {};
          this.contestOpp.status = 'success';
          this.contestOpp.data = res.entities;
          this.matchUpPositions();
          if (this.contestOpp.data.lgm_list != null && this.contestOpp.data.lgm_list.length) {
            this.contestOpp.data.lgm_list.forEach(lgm => {
              if (lgm.slug == this.oppTeamSlug) {
                this.oppTeamImg = lgm.team_image;
              }
            });
          }
        }
      }
      else {
        this.router.navigate(['/lobby']);
      }
    });
  }
  
  loadOppPlayersWeek(selectedWeek) {
    this.isLoading = true;
    this._myTeamsService.getContestPlayersWeek(this.oppTeamSlug, selectedWeek).subscribe(res => {
      if (res.status == true) {
        if (res.entities.league_id != this.lgId) {
          this.router.navigate(['/lobby']);
        }
        else {
          this.contestOpp = {};
          this.contestOpp.status = 'success';
          this.contestOpp.data = res.entities;
          this.matchUpPositions();
          if (this.contestOpp.data.lgm_list != null && this.contestOpp.data.lgm_list.length) {
            this.contestOpp.data.lgm_list.forEach(lgm => {
              if (lgm.slug == this.oppTeamSlug) {
                this.oppTeamImg = lgm.team_image;
              }
            });
          }
        }
      }
      else {
        this.router.navigate(['/lobby']);
      }
    });
  }
  
  getHeight(element) {
    const top = element.getBoundingClientRect().top;
    const wH = window.innerHeight;
    return wH - top - ((this.isMobile) ? 70 : 10);
  }
  
  printPlayerName(player) {
    if (player.gp_id == 16) {
      return player.fn;
    }
    return (this.isMobile) ? `${player.fn.substr(0, 1)}. ${player.ln}` : `${player.fn} ${player.ln}`;
  }
  
  openPlayerInfoBox(player, player_id, e) {
    e.preventDefault();
    e.stopPropagation();
    if ((player.infobox == null || player.infobox == 1) && player_id) {
      this.dialog.open(Playerinfobox2Component, {
        width: (this.isMobile) ? '90%' : '70%',
        height: 'auto',
        autoFocus: false,
        data: {
          isDraft: false,
          league: {
            game_id: this.contest.data.game_id,
            id: this.contest.data.league_id,
            abbr: this.games[this.contest.data.game_id],
            active_season_id: null
          },
          lgm_id: this.contest.data.lgm_id,
          players: [],
          player_data : {'pp' : player.pic, 'fn' : player.fn, 'ln' : player.ln},
          player_id
        }
      });
    }
  }
  
  changeWeek() {
    this.isLoading = true;
    this._myTeamsService.getContestPlayersWeek(this.contest.data.slug, this.contest.data.selectedWeek).subscribe(res => {
      if (res.status) {
        const selectedWeek = this.contest.data.selectedWeek;
        this.contest.data = res.entities;
        this.contest.data.opp_list = [];
        if (this.contest.data.lgm_list != null && this.contest.data.lgm_list.length) {
          this.contest.data.lgm_list.forEach(lgm => {
            if (lgm.slug != this.teamSlug) {
              this.contest.data.opp_list.push(lgm);
              if (!this.oppTeamSlug) {
                this.oppTeamSlug = lgm.slug;
                this.loadOppPlayersWeek(selectedWeek);
              }
              else if (this.oppTeamSlug == lgm.slug) {
                this.loadOppPlayersWeek(selectedWeek);
              }
            }
            else {
              this.ownTeamImg = lgm.team_image;
            }
          });
        }
        this.contest.data.selectedWeek = selectedWeek;
      }
      this.isLoading = false;
    });
  }
  
  changeLgm(slug) {
    this.oppTeamSlug = slug;
    this.loadContest();
  }
  
  prettyPrint(number) {
    const rem = number % 100;
    if (rem > 10 && rem < 21) {
      return number + 'th';
    } 
    else {
      const rem2 = number % 10;
      if (rem2 == 1) return number + 'st';
      if (rem2 == 2) return number + 'nd';
      if (rem2 == 3) return number + 'rd';
      return number + 'th';
    }
  }
  
  checkTeamResult(type) {
    let resultColor = '';
    if (this.contest.data.lg_status != 3) {
      return '';
    }
    else if (type == 'own') {
      if (this.contest.data.team_total > this.contestOpp.data.team_total) {
        resultColor = 'rgb(15, 140, 30)';
      }
      else if (this.contest.data.team_total < this.contestOpp.data.team_total) {
        resultColor = 'rgb(215, 0, 0)';
      }
    }
    else {
      if (this.contestOpp.data.team_total > this.contest.data.team_total) {
        resultColor = 'rgb(15, 140, 30)';
      }
      else if (this.contestOpp.data.team_total < this.contest.data.team_total) {
        resultColor = 'rgb(215, 0, 0)';
      }
    }
    return resultColor;
  }
  
  matchUpPositions() {
    let playersOwn = this.contest.data.players;
    let playersOpp = this.contestOpp.data.players;
    
    let numOfPlayers = playersOwn.length;
    let lastPos = '';
    
    for (let key = 0; key < numOfPlayers; key++) {
      let playerOwn = playersOwn[key] || {};
      let playerOpp = playersOpp[key] || {};
      
      if (playerOwn.hasOwnProperty('pick_rp') || playerOpp.hasOwnProperty('pick_rp')) {
        if (!playerOwn.hasOwnProperty('pick_rp')) {
          playerOwn.pick_rp = playerOpp.pick_rp;
        }
        else if (!playerOpp.hasOwnProperty('pick_rp')) {
          playerOpp.pick_rp = playerOwn.pick_rp;
        }
        
        let posOwn = this.draftPosition(this.contest.data.draft_type, playerOwn);
        let posOpp = this.draftPosition(this.contest.data.draft_type, playerOpp);
        if (posOwn != posOpp) {
          if (posOwn == lastPos) {
            playersOpp.splice(key, 0, {pick_rp: lastPos});
            playersOwn.push({});
          }
          else {
            playersOwn.splice(key, 0, {pick_rp: lastPos});
            playersOpp.push({});
          }
          numOfPlayers++;
        }
        else {
          lastPos = posOwn;
        }
      }
    }
    this.isLoading = false;
  }
  
  draftPosition(draftType, player) {
    let position = player.pick_rp;
    if (draftType == 5 && player.hasOwnProperty('pn_tier')) {
      position = `Tier ${player.pn_tier}`;
    }
    else if (this.positions[position]) {
      position = this.positions[position];
    }
    return position;
  }
  
  isNumeric(num) {
    return (typeof(num) === 'number' || typeof(num) === "string" && num.trim() !== '') && !isNaN(num as any);
  }
}
